import usePrivateAxios from "@/common/api/usePrivateAxios"
import { ReasonValidationSchema } from "@/common/schemas/reason.schema"
import { useMutation } from "@tanstack/react-query"

interface UseArchiveEstablishmentProps {
  establishmentLeadId?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useArchiveEstablishmentLead = ({
  establishmentLeadId,
  onSuccess,
  onError,
}: UseArchiveEstablishmentProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['archiveEstablishment'],
    mutationFn: async ({ log_reason, newStatus }: { log_reason: ReasonValidationSchema, newStatus: string }) => {
      await privateAxios.put(`/funnel/establishment/leads/${establishmentLeadId}/${newStatus}`, { log_reason })
    },
    onSuccess,
    onError,
  })
}
